import { motion, AnimatePresence } from "framer-motion";
import { CheckCircle2, X, AlertTriangle } from "lucide-react";

export default function Alert({ type = "error", children, onClose, testId }) {
  const isError = type === "error";
  return (
    <AnimatePresence>
      {children && (
        <motion.div
          initial={{ opacity: 0, y: -6, height: 0 }}
          animate={{ opacity: 1, y: 0, height: "auto" }}
          exit={{ opacity: 0, y: -6, height: 0 }}
          transition={{ duration: 0.25, ease: "easeOut" }}
          data-testid={testId}
          className={`flex items-start gap-3 rounded-xl border px-3.5 py-3 text-sm ${
            isError
              ? "border-[hsl(356,85%,88%)] bg-[hsl(356,85%,97%)] text-[hsl(356,78%,35%)]"
              : "border-[hsl(152,55%,80%)] bg-[hsl(152,55%,96%)] text-[hsl(152,60%,25%)]"
          }`}
        >
          {isError ? (
            <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" strokeWidth={2} />
          ) : (
            <CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0" strokeWidth={2} />
          )}
          <div className="flex-1 leading-relaxed">{children}</div>
          {onClose && (
            <button
              type="button"
              onClick={onClose}
              className="rounded-md p-0.5 hover:bg-black/5"
              aria-label="Dismiss"
              data-testid={testId ? `${testId}-close` : undefined}
            >
              <X className="h-4 w-4" />
            </button>
          )}
        </motion.div>
      )}
    </AnimatePresence>
  );
}
